<script>
    export default {
        name: "CommercialPolicyMixin",
        props:['policyData', 'currencies'],
        data() {
            return {
                policies: []
            }
        },
        created() {
            this.policies = Array.isArray(this.policyData) ? [... this.policyData] : {...this.policyData};
        },
        methods: {
            changePolicy() {
                this.$emit('change', this.policies);
            },
            deletePolicy(id) {
                this.$emit('delete-policy', id);
            }
        },
        watch: {
            policyData: {
                handler() {
                    this.policies = Array.isArray(this.policyData) ? [... this.policyData] : {...this.policyData};
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>